import { Asset } from 'contentful';
import { TypeOrientedMedia } from '../../../@types/generated';

export function toImageFromContentfulMedia(
  media?: TypeOrientedMedia | Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>,
) {
  function isAsset(media: TypeOrientedMedia | Asset): media is Asset {
    return !('contentType' in media.sys);
  }
  if (!media) {
    return undefined;
  }

  if (isAsset(media)) {
    if (!media?.fields.file?.url) {
      return undefined;
    }

    return {
      url: media.fields.file?.url,
      alt: media.fields.description ?? media.fields.title ?? '',
    };
  }

  const image = media?.fields.imageLandscape ?? media?.fields.imagePortrait;

  if (!image?.fields.file?.url) {
    return undefined;
  }

  return {
    url: image?.fields.file?.url,
    alt: image?.fields.title ?? image?.fields.description ?? '',
    credit: media.fields.credit,
  };
}
